import { Entry } from "contentful";

export function isEntry(item: unknown): item is Entry {
  return (item as Entry)?.sys?.type === "Entry";
}
